import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {ReportTools} from './reportTools.js';


/* global customElements */
class DistancePrefReport extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
						
		var distancePrefReport = this;
		setTimeout(function(){
			distancePrefReport.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var distancePrefReport = this;
				
		var chartCourse = ElementUtil.create({
			tag: 'dl-chart-panel',
			slot: 'primary',
			listeners: {
				ready: function() {
					chartCourse.createChart();
				}
			}
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				chartCourse
			]
		});		
		distancePrefReport.append(flexLayout);					
	
	}
	
}
customElements.define('dl-distance-prefreport', DistancePrefReport);
